module.exports = __webpack_public_path__ + "static/img/10.d250149.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/12/sp/10.png
// module id = U8qY
// module chunks = 0